import mod from "-!./index.js?vue&type=script&lang=js&"; export default mod; export * from "-!./index.js?vue&type=script&lang=js&"